import * as amplitude from "@amplitude/analytics-browser"

export default async function setUserProperties(
  propertyList: Record<string, any>,
) {
  const identifyEvent = new amplitude.Identify()

  Object.keys(propertyList).forEach(property => {
    identifyEvent.set(property, propertyList[property])
  })
  await amplitude.identify(identifyEvent).promise
}

export async function appendValuesToUserProperty(
  property: string,
  values: string[],
) {
  const identifyEvent = new amplitude.Identify()
  identifyEvent.postInsert(property, values)
  await amplitude.identify(identifyEvent).promise
}
